export default __webpack_public_path__ + "static/mingling-9d3e94cae007c6262471619242a6a38f.svg";